import React from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import { NFService, StatusNFSe } from '../../../services/tipos';

interface ModalDetalhesNotaProps {
    show: boolean;
    onHide: () => void;
    nota: NFService | null;
}

const ModalDetalhesNota: React.FC<ModalDetalhesNotaProps> = ({ show, onHide, nota }) => {
    if (!nota) return null;

    const formatMoney = (val: number) => val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    const formatDate = (date?: Date) => date ? new Date(date).toLocaleString() : '-';

    // Função ajustada para retornar o badge estilizado (Backgroundzin)
    const renderStatusBadge = (status: StatusNFSe) => {
        let text = '';
        let backgroundColor = '#808080'; // Default gray

        switch (status) {
            case StatusNFSe.Processando:
                backgroundColor = '#FFC107'; // Amber
                text = 'Processando';
                break;
            case StatusNFSe.Emitida:
                backgroundColor = '#4CAF50'; // Green
                text = 'Emitida';
                break;
            case StatusNFSe.Cancelada:
                backgroundColor = '#f44336'; // Red
                text = 'Cancelada';
                break;
            case StatusNFSe.Erro:
                backgroundColor = '#f44336'; // Red
                text = 'Erro';
                break;
            case StatusNFSe.Agendada:
                backgroundColor = '#007bff'; // Blue
                text = 'Agendada';
                break;
            default:
                text = 'Desconhecido';
        }

        return (
            <span style={{
                backgroundColor,
                color: 'white',
                padding: '5px 10px',
                borderRadius: '5px',
                fontWeight: 'bold',
                textAlign: 'center',
                display: 'inline-block',
                minWidth: '80px'
            }}>
                {text}
            </span>
        );
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header>
                <Modal.Title>Detalhes da Nota Fiscal</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="p-2">
                    <Row className="mb-3">
                        <Col md={6}>
                            <strong>Locatário:</strong> <br /> {nota.nomeLocatario || '-'}
                        </Col>
                        <Col md={6}>
                            <strong>Pagamento Referente:</strong> <br /> {nota.descricaoPagamento || '-'}
                        </Col>
                    </Row>
                    
                    <hr />

                    <Row className="mb-3">
                         <Col md={4}>
                            <strong>Número (RPS):</strong> <br /> {nota.numeroNota || '-'}
                        </Col>
                        <Col md={4}>
                            <strong>Protocolo:</strong> <br /> {nota.protocolo || '-'}
                        </Col>
                        <Col md={4}>
                            <strong>Status:</strong> <br /> 
                            {renderStatusBadge(nota.status)}
                        </Col>
                    </Row>

                    <Row className="mb-3">
                         <Col md={4}>
                            <strong>Valor:</strong> <br /> {formatMoney(nota.valor)}
                        </Col>
                        <Col md={4}>
                            <strong>Data Emissão:</strong> <br /> {formatDate(nota.dataHoraEmissao)}
                        </Col>
                        <Col md={4}>
                            <strong>Competência:</strong> <br /> {formatDate(nota.competencia)}
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md={12}>
                            <strong>Chave da Nota:</strong> <br /> {nota.chaveNota || '-'}
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md={12}>
                            <strong>Código de Verificação:</strong> <br /> {nota.codigoVerificacao || '-'}
                        </Col>
                    </Row>

                    {nota.linkNota && (
                        <Row className="mb-3">
                            <Col md={12}>
                                <strong>Link da Nota:</strong> <br /> 
                                <a href={nota.linkNota} target="_blank" rel="noreferrer">{nota.linkNota}</a>
                            </Col>
                        </Row>
                    )}

                    {nota.mensagemErro && (
                         <div className="alert alert-danger mt-3">
                            <strong>Mensagem de Erro:</strong> <br />
                            {nota.mensagemErro}
                         </div>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalDetalhesNota;